// This carousel uses /_js/global/vendor/slick.js. Docs can
// be found at: http://kenwheeler.github.io/slick/

$(document).ready(function() {

  // ===============================================================================================
  // The Project-specific carousel
  // ===============================================================================================
  $('.carousel--project .carousel__items').slick({

    // These settings apply by default:
    adaptiveHeight: true,
    autoplay: true,
    prevArrow: '<button class="strip-button slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72"><style>.icon-chevron-arrow{fill:none;stroke-width:2.4482;stroke-miterlimit:10;}</style><circle class="icon-chevron-bg" cx="36" cy="36" r="36"/><path class="icon-chevron-arrow" d="M41.1 13.5L18.9 35.7l22.2 22.2"/></svg></button>',
    nextArrow: '<button class="strip-button slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72"><style>.icon-chevron-arrow{fill:none;stroke-width:2.4482;stroke-miterlimit:10;}</style><circle class="icon-chevron-bg" cx="36" cy="36" r="36"/><path class="icon-chevron-arrow" d="M41.1 13.5L18.9 35.7l22.2 22.2"/></svg></button>',

    // Viewport-width-based settings:
    responsive: [
      // {
      //   // These settings apply below (but not including) 900px:
      //   breakpoint: 900,
      //   settings: {

      //   }
      // },
      {
        // These settings apply below (but not including) 861px:
        breakpoint: 861,
        settings: {
          arrows: false
        }
      }
    ]

  });


  // ===============================================================================================
  // The Full-width-specific carousel
  // ===============================================================================================
  $('.carousel--full-width .carousel__items').slick({

    // These settings apply by default:
    adaptiveHeight: true,
    arrows: false,
    autoplay: true

    // Viewport-width-based settings:
    // responsive: [
    //   {
    //     // These settings apply below (but not including) 900px:
    //     breakpoint: 900,
    //     settings: {

    //     }
    //   },
    //   {
    //     // These settings apply below (but not including) 861px:
    //     breakpoint: 861,
    //     settings: {

    //     }
    //   }
    // ]

  });

});
